<template>
  <div>
    <base-auto-fill-dates :number-of-parts="retend.numberOfParts + retend.numberOfAdditionalParts"
                          :lot-rules="retend.schedule.deliveryTypes"
                          :date-label="$t('form.lot.start-date-of-period-for-delivery')"
                          :parts-label="$t('form.lot.parts-for-delivery-dates')"
                          :hint="$t('form.lot.fill-dates-in-delivery-dates-sections')"
                          :can-edit-rules="canEditRetend"
                          @apply="onAutoFillDeliveryRulesClick"
                          v-if="retend.schedule.deliveryTypes">
    </base-auto-fill-dates>

    <div class="a-container-form admin-buy__block" >
      <div class="a-label a-label--w-340"></div>
      <div class="a-width-100-percent border-bottom"></div>
    </div>

    <base-auto-fill-dates :number-of-parts="retend.numberOfParts + retend.numberOfAdditionalParts"
                          :lot-rules="retend.schedule.paymentTypes"
                          :parts-label="$t('form.lot.parts-for-payment-dates')"
                          :hint="$t('form.lot.fill-dates-in-delivery-bid-template-section')"
                          :can-edit-rules="canEditRetend"
                          @apply="onAutoFillPaymentTypesClick"
                          v-if="retend.schedule.paymentTypes">
    </base-auto-fill-dates>
  </div>
</template>

<script>
  import { required, between } from '@/validators'
  import PermissionsMixins from '../mixins/permissions';
  import CommonMixins from '../mixins/common';
  import BaseAutoFillDates from "../common/base-AutoFillDates";

  export default {
    components: {
      BaseAutoFillDates
    },

    props: {
      retend: {
        type: Object,
        required: true
      },

      lot: {
        type: Object,
        required: true
      }
    },

    mixins: [
      PermissionsMixins,
      CommonMixins
    ],

    methods: {
      async onAutoFillDeliveryRulesClick(rules) {
        this.retend.applyRules({
          deliveryTypes: rules
        });

        await this.saveForm(this.retend);
      },

      async onAutoFillPaymentTypesClick(rules) {
        this.retend.applyRules({
          paymentTypes: rules
        });

        await this.saveForm(this.retend);
      }
    }
  }
</script>

<style scoped>
</style>
